import '../admin/admin.css';
import { EDiscoveryPanel } from '../admin/ediscovery';
import { AdminWhereContext, TENANT_WHERE } from '../admin/mailboxes';

/**
 * eDiscovery in webmail, for members of the organisation's
 * `ZitiMail-eDiscovery` group: granted on its own, so it is not part of the
 * Organisation view and needs no administrator role.
 */
export function EDiscoveryView({
  slug,
  onBack,
}: {
  slug: string;
  onBack: () => void;
}): JSX.Element {
  return (
    <main className="main adm tenant-admin">
      <div className="adm-head">
        <span className="adm-actions">
          <button type="button" className="btn ghost" onClick={onBack}>
            ← Mail
          </button>
        </span>
      </div>
      <AdminWhereContext.Provider value={TENANT_WHERE}>
        <EDiscoveryPanel slug={slug} />
      </AdminWhereContext.Provider>
    </main>
  );
}
